import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { AdminGuard } from './auth/admin.guard';
import { StaticSiteComponent } from './static-site/static-site.component';
import { SmsTrackingComponent } from './sms-tracking/sms-tracking.component';
import { AuthGuard } from './auth/auth.guard';
const appRoutes: Routes = [
  {
    path: '',
    // REPLACE  StaticSiteComponent for homepage to show
    component: StaticSiteComponent,
    pathMatch: 'prefix',
    loadChildren: () => import('./static-site/static-site.module').then((m) => m.StaticSiteModule),
    data: { breadcrumb: 'Homepage' },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { breadcrumb: 'Login' },
  },
  {
    path: 'register',
    component: LoginComponent,
    data: { breadcrumb: 'Register' },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'o/:id',
    component: SmsTrackingComponent,
    data: { breadcrumb: 'Order-Tracking' },
  },
  {
    path: 'order-tracking',
    component: SmsTrackingComponent,
    data: { breadcrumb: 'Order-Tracking' },
  },
  {
    path: 'admin',
    data: { breadcrumb: 'Admin' },
    canActivate: [AdminGuard, AuthGuard],
    component: AdminComponent,
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
